import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import {
	ChartComponent,
	ApexAxisChartSeries,
	ApexChart,
	ApexXAxis,
	ApexDataLabels,
	ApexTooltip,
	ApexStroke,
	ApexYAxis
} from "ng-apexcharts";
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
import { AnalyticsService } from '../analytics/analytics.service';
import { UsersService } from '../../../management/components/tabs/components/users/users.service';
import { SharedService } from '../../../../shared/shared.service';
import { MatSort } from '@angular/material/sort';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from 'xlsx';
import { DashboardService } from 'src/app/modules/learning-center/components/my-dashboard/my-dashboard.service';
import { PostHogService } from 'src/app/shared/services/posthog.service';
import {
	POSTHOG_EVENT_EXPORT_ANALYTICS_PROGRAM_LIST,
	POSTHOG_EVENT_SHOW_ANALYTICS_PROGRAM_LIST,
	POSTHOG_EVENT_HIDE_ANALYTICS_PROGRAM_LIST
} from 'src/app/shared/constants/posthog-events.constants';
import { DeviceDetectorService } from 'ngx-device-detector';
import moment from 'moment';

export type ChartOptions = {
	series: ApexAxisChartSeries;
	chart: ApexChart;
	xaxis: ApexXAxis;
	yaxis: ApexYAxis;
	stroke: ApexStroke;
	tooltip: ApexTooltip;
	dataLabels: ApexDataLabels;
};

@Component({
	selector: 'app-analytics-main',
	templateUrl: './analytics-main.component.html',
	styleUrls: ['./analytics-main.component.scss']
})
export class AnalyticsMainComponent implements OnInit {

	@ViewChild('carousel') carousel!: NgbCarousel;
	headerTitle: any = 'Admin Analytics';
	showPageRoute: any = true;
	showBackButtonBlack: any = true;
	config: SwiperOptions = {
		slidesPerView: 5,
		spaceBetween: 50,
		navigation: true,
		pagination: { clickable: true },
		scrollbar: { draggable: true },
	};
	// headerTitle = " "
	public chartOptions!: Partial<ChartOptions> | any;
	dailyDoseBars: any = [20, 40, 30, 20, 50, 30, 50, 20, 50, 20, 20, 40, 30, 60, 50, 30, 50, 20, 60, 20, 20, 40, 30, 60, 50, 30, 50, 20, 20, 20];
	progressTableColumnNames: string[] = ["name", "programName", "started", "completed", "progress", "avgQuizScore", "earnedPts"];
	progressData: MatTableDataSource<any>;
	orgId: any;
	orgLevels: any = [];
	blockLoader: string = "blockLoader";
	avgStreakPerPerson: number = 0;
	avgLearningTime: string = "0m";
	avgLoginTime: string = "0m";
	coursesInProgress: number = 0;
	avgPointsPerPerson: number = 0;
	avgQuizScore: number = 0;
	turnoverRate: number = 0;
	engagementScore: number = 0;
	numberOfLocations: number = 0;
	numberOfUsers: number = 0;
	currentMonth: string = "";
	currentYear: string = "";
	currentMonthAndYear: string = "";
	currentMonthName: string = "";
	orgData: any;
	allPrograms: any;
	allUsersInOrg: any;
	allUserIdsInOrg: any = [];
	userId: string = "";
	managerAtLevelValues: any = [];
	managerAtLevelNumber: number = -1;
	currLevels: any = [];
	prevLevels: any = [];
	allSystemPrograms: any = [];
	selectedProgramId: string = "all";
	dropdownOptions: any = [];
	userActivePrograms: any = [];
	hasProgress: boolean = false;
	companyAverage: number = -1;
	favoriteCategories: any = [];
	tableData: any = [];
	analyticsButtonStatus: boolean = false;
	dataPlotted = false;
	gotUpdatedData: boolean = false;
	lastUpdatedAt: any = null;
	dosesCompleted: number = 0;
	isRebuildingAnalytics: boolean = false;
	@ViewChild("chart") chart!: ChartComponent;
	@ViewChild('cardElement') cardElement!: ElementRef;
	@ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
	@ViewChild('TABLE') table!: ElementRef;
	// @ViewChild('paginatorUsers') paginatorUsers!: MatPaginator;
	@ViewChild(MatPaginator)
	paginator!: MatPaginator;
	@ViewChild(MatSort) sort: any;
	programCompletion: any = [];
	comparisonSelection: any;
	compareBoxes: any = [];
	compareBoxesPrograms: any = [];
	userName: string | null;
	userPic: string | null;
	isExpand: boolean = false;
	public chartOptions2: Partial<ChartOptions> | any;
	dyanamicHeight: number = 200;
	teamAverage: number = -1;
	industryAverage: number = -1;
	firstName: string = '';
	userData: any;
	teamAnalyticsData: any;
	newLearnersThisMonth: number = 0;
	rolesData: any = {};
	allRoleIds: any = [];
	teamAveragePercentage: any = -1;
	companyAveragePercentage: any = 1;
	industryAveragePercentage: any = -1;
	isShowDataEnabled: boolean = true;
	isShowTeamEnabled: boolean = false;
	lastLevelValue: string = "all";
	stmPrograms: any = [];
	showTeamMembers: any = [];
	rolesKeys: any;
	selectedRoles: string[] = [];
	isAllRolesSelected = false;
	getFilteredProgramsFnInitialCall = true;

	// @ViewChild("chart") chart!: ChartComponent;
	// public chartOptions!: Partial<ChartOptions> | any;

	constructor(
		private snackbar: MatSnackBar,
		private spinner: NgxSpinnerService,
		private analyticsService: AnalyticsService,
		private usersService: UsersService,
		private sharedService: SharedService,
		private dashboardService: DashboardService,
		private posthog: PostHogService,
		private deviceDetectorService: DeviceDetectorService
	) {
		this.chartOptions = {
			colors: ['#7775EA'],

			grid: {
				show: false,
			},


			series: [

				{
					name: "series1",
					data: [10, 20, 30]
				},
				// {
				//   name: "series2",
				//   data: [11, 32, 45, 32, 34, 52, 41]
				// }
			],
			chart: {
				height: 70,
				width: '120',
				type: "area",
				toolbar: {
					show: false,
				}
			},
			dataLabels: {
				enabled: false
			},
			stroke: {
				curve: "smooth"
			},

			yaxis: {
				axisTicks: {
					show: false
				},
				axisBorder: {
					show: false
				},

				min: 0, max: 100, tickInterval: 25,
				title: {
					text: "title"
				},

			},


			xaxis: {
				axisTicks: {
					show: false
				},
				axisBorder: {
					show: false
				},
				lines: {
					show: false
				},
				labels: {
					show: false
				},
				type: "area",
			},
			tooltip: {
				x: {
					// format: "dd/MM/yy HH:mm"
				}
			}
		};

		this.progressData = new MatTableDataSource();

		this.currentYear = this.sharedService.getCurrentYearString();
		this.currentMonthName = this.sharedService.getCurrentMonthName();
		this.currentMonth = this.sharedService.getCurrentMonth();
		this.currentMonthAndYear = `${this.currentMonth}-${this.currentYear}`;

		this.sharedService.activePrograms$.subscribe(activePrograms => {
			// console.log(activePrograms);
			this.userActivePrograms = activePrograms;
			if (this.userActivePrograms.length >= 1) {
				this.hasProgress = true;
			} else {
				this.hasProgress = false;
			}
		});

		this.userName = localStorage.getItem('firstName');
		this.userPic = localStorage.getItem('userPic');
		this.orgId = localStorage.getItem('orgId') ?? "";
		this.userId = localStorage.getItem('userId') ?? "";

		if (this.userName) {
			const fullName = this.userName.split(" ");
			this.firstName = fullName[0];
		}

		this.dashboardService.teamAnalyticsDataFetch$.subscribe(async (status) => {
			if (status === "pending") {
				this.gotUpdatedData = false;
				this.dataPlotted = false;
			} else if (status === "resolved") {
				this.gotUpdatedData = true;
				this.dataPlotted = true;
				this.teamAnalyticsData = this.dashboardService.teamAnalyticsData;
				await this.analyticsProcessing();
			} else if (status === "sleeping") {
				await this.dashboardService.getTeamAnalyticsData(this.orgId);
			}
		});
	}

	async analyticsProcessing() {
		await this.refreshOrgData();

		if (this.orgData && this.orgData.name) {
			this.getManagingDetails();
			this.ensureCurrLevelsInitialized();
			this.updateDropdownValues();
			this.ensureDefaultLevelSelections();
			this.getProgressData();

			this.userData = await this.dashboardService.getUserData();
			for (let roleId of this.allRoleIds) {
				const roleData: any = await this.sharedService.getRoleData(roleId);
				this.rolesData[String(roleId)] = roleData.name;
			}
			// Extract keys to iterate over
			// this.rolesKeys = Object.keys(this.rolesData);

			// Sort role keys alphabetically by role name
			this.rolesKeys = Object.keys(this.rolesData).sort((a, b) => {
				const nameA = this.rolesData[a]?.toLowerCase() || '';
				const nameB = this.rolesData[b]?.toLowerCase() || '';
				return nameA.localeCompare(nameB);
			});

			this.selectedRoles = ['all', ...this.rolesKeys.map((key: any) => key)];
			this.isAllRolesSelected = true;

			await this.filtering();
			this.generateIndustryAverage().then(() => { });
			this.generateCompanyAverage();
			// this.userData = await this.dashboardService.getUserData();
			// for (let roleId of this.allRoleIds) {
			// 	const roleData: any = await this.sharedService.getRoleData(roleId);
			// 	this.rolesData[String(roleId)] = roleData.name;
			// }
			// // Extract keys to iterate over
			// this.rolesKeys = Object.keys(this.rolesData);
			// this.selectedRoles = ['all', ...this.rolesKeys.map((key: any) => key)];
			// this.isAllRolesSelected = true;

			// console.log(this.rolesData);
			this.dosesCompleted = this.getDosesCompleted();
			this.generateTeamAverage();
		} else {
			setTimeout(async () => {
				await this.analyticsProcessing();
			}, 500);
		}
	}

	async ngOnInit() {
		this.chartOptions2 = {
			series: [{
				name: 'Time Speed',
				data: [60, 90, 120, 75, 180, 150, 90, 120, 105, 135, 90, 150]
			}],
			chart: {
				type: 'bar',
				height: 150
			},
			plotOptions: {
				bar: {
					horizontal: false,
					columnWidth: '45%',
					endingShape: 'rounded'
				},
			},
			dataLabels: {
				enabled: false
			},
			stroke: {
				show: true,
				width: 2,
				colors: ['transparent']
			},
			xaxis: {
				categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
			},
			yaxis: {
				title: {
					text: 'Time Speed'
				}
			},
			fill: {
				opacity: 1
			},
			tooltip: {
				y: {
					formatter: function (val: any) {
						return "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
					}
				}
			}
		}

		if (this.orgId) {
			await this.spinner.show("blockLoader");
			await this.getOrgLevels();
			await this.spinner.hide("blockLoader");

			if (this.orgData && this.orgData.allowedPrograms && this.orgData.allowedPrograms.length >= 1) {
				for (let programId of this.orgData.allowedPrograms) {
					const programData: any = await this.sharedService.getProgramData(programId);
					if (programData && Object.keys(programData).length >= 1) {
						this.allSystemPrograms.push({
							id: programId,
							name: programData.name
						});
					}
				}
			} else {
				this.allSystemPrograms = await this.analyticsService.getAllSystemPrograms();
			}
			this.selectedProgramIds = ['all', ...this.allSystemPrograms.map((program: any) => program.id)];
			this.allSelected = true;
		}
	}

	ngAfterViewInit() {
		// console.log('this.paginator', this.paginator)
		this.paginatorSetup();
		setTimeout(() => {
			this.getImageDimensions();
		}, 2000);
	}

	paginatorSetup() {
		setTimeout(() => {
			if (this.gotUpdatedData) {
				this.progressData.paginator = this.paginator;
			} else {
				this.paginatorSetup();
			}
		}, 1000);
	}

	async getOrgLevels() {
		this.orgData = await this.analyticsService.getOrgData(this.orgId);
		this.analyticsButtonStatus = Boolean(this.orgData.analyticsGenerated);
		this.lastUpdatedAt = this.toDateValue(this.orgData.analyticsUpdatedAt);

		for (let hierarchy of this.orgData.hierarchies) {
			this.orgLevels.push(hierarchy);
		}
		// console.log(this.orgLevels);

		if (this.orgLevels?.length >= 1) {
			for (let i = this.orgLevels.length - 1; i >= 0; i -= 1) {
				this.progressTableColumnNames.unshift(this.orgLevels[i]);
			}
		}
	}

	getProgressData() {
		// this.allUsersInOrg = await this.usersService.getAllUsers(this.orgId);
		this.allUsersInOrg = this.teamAnalyticsData;
		this.allUserIdsInOrg = [];
		this.allRoleIds = [];
		this.rolesData = {};

		for (let user of this.allUsersInOrg) {
			user.progressData = this.sharedService.normalizeAndDedupeProgress(user.progressData || []);
			this.allUserIdsInOrg.push(user.id);
			for (let k = 0; k < user.level.length; k += 1) {
				let lvl = user.level[k];
				let checkVal = lvl.value;
				user.level[k].displayValue = this.getDisplayValue(checkVal, k);
			}

			if (!this.allRoleIds.includes(user.roleId)) {
				this.allRoleIds.push(user.roleId);
			}
		}

		this.allPrograms = [];
		for (let user of this.allUsersInOrg) {
			for (let program of user.progressData) {
				program.progress = this.sharedService.normalizeProgress(program.progress);
				this.allPrograms.push(program);
			}
		}

		for (let program of this.allPrograms) {
			program.startedAt = this.toDateValue(program.startedAt);
			program.completedAt = this.toDateValue(program.completedAt);
		}
	}

	getDisplayValue(value: string, k: number) {
		let currValues = this.orgData.hierarchy[k].values;

		for (let i = 0; i < currValues.length; i += 1) {
			let lvl = currValues[i];
			if (lvl.value === value) {
				return lvl.displayValue;
			}
		}

		return "";
	}

	async getUpdatedStats() {
		this.allPrograms = await this.analyticsService.getAnalyticsData(this.orgId);

		for (let program of this.allPrograms) {
			program.startedAt = this.toDateValue(program.startedAt);
			program.completedAt = this.toDateValue(program.completedAt);
		}
	}

	async changeCurrLevels(index: number, value: string) {
		this.currLevels[index] = value;
		this.updateDropdownValues();

		if (index + 1 === this.orgLevels.length) {
			this.lastLevelValue = value;
			// this.showTeamMembersComparison();
		}
		// await this.filtering();
	}

	showTeamMembersComparison() {
		this.stmPrograms = [];
		this.showTeamMembers = [];

		if (this.lastLevelValue !== "all") {
			const usersAtLocation = this.allUsersInOrg.filter((user: any) => {
				let isUserAtLocation = true;
				for (let i = 0; i < this.currLevels.length; i += 1) {
					if ((!user.level[i] || (user.level[i].value !== this.currLevels[i])) && this.currLevels[i] !== "all") {
						isUserAtLocation = false;
						break;
					}
				}

				if (isUserAtLocation) {
					return true;
				} else {
					return false;
				}
			});

			let usersAtLocationIds: any = [];
			for (let user of usersAtLocation) {
				usersAtLocationIds.push(user.id);
			}

			const filteredProgress = this.tableData.filter((progress: any) => {
				const userId = progress.userId;
				return usersAtLocationIds.includes(userId);
			});

			for (let progress of filteredProgress) {
				let isProgramAdded = false;
				for (let i = 0; i < this.stmPrograms.length; i += 1) {
					if (this.stmPrograms[i].id === progress.programId) {
						isProgramAdded = true;
						break;
					}
				}

				if (!isProgramAdded) {
					this.stmPrograms.push({
						id: progress.programId,
						name: progress.programName
					});
				}
			}

			for (let user of usersAtLocation) {
				let programs: any = [];
				for (let program of this.stmPrograms) {
					programs.push({
						programId: program.id,
						completedPercentage: 0,
						remainingPercentage: 100,
						hasEnrolled: false
					});
				}

				this.showTeamMembers.push({
					userId: user.id,
					displayName: user.name,
					programs
				})
			}

			for (let progress of filteredProgress) {
				const stmProgramsIndex = this.stmPrograms.findIndex((program: any) => {
					return program.id === progress.programId;
				});

				const showTeamMembersIndex = this.showTeamMembers.findIndex((member: any) => {
					return progress.userId === member.userId;
				});

				this.showTeamMembers[showTeamMembersIndex].programs[stmProgramsIndex] = {
					programId: progress.programId,
					completedPercentage: progress.progress,
					remainingPercentage: 100 - progress.progress,
					hasEnrolled: true
				};
			}
		} else {
			console.log("last selection event all!");
			this.isShowTeamEnabled = false;
		}
	}

	async generateFilteredResults() {
		// this.stmPrograms = [];
		// this.showTeamMembers = [];
		this.isShowDataEnabled = false;
		this.isShowTeamEnabled = false;
		await this.filtering();
		this.isShowDataEnabled = true;
		this.showTeamMembersComparison();
	}

	async rebuildAnalytics() {
		if (!this.orgId || this.isRebuildingAnalytics) {
			return;
		}

		this.isRebuildingAnalytics = true;
		this.gotUpdatedData = false;
		this.snackbar.open("Rebuilding team analytics...", "OK");

		try {
			await this.dashboardService.rebuildTeamAnalytics(this.orgId);
			await this.dashboardService.getTeamAnalyticsData(this.orgId);
			await this.refreshOrgData();
			this.snackbar.open("Team analytics rebuilt.", "OK");
		} catch (err) {
			console.log(err);
			this.gotUpdatedData = true;
			this.snackbar.open("Unable to rebuild team analytics right now.", "OK");
		} finally {
			this.isRebuildingAnalytics = false;
		}
	}

	async filtering() {
		// console.log(this.currLevels);
		this.compareBoxes = [];
		this.compareBoxesPrograms = [];
		this.comparisonSelection = "";
		const filteredUsers = this.getFilteredUsers();
		this.numberOfLocations = this.getNumberOfLocations();
		// console.log('numberOfLocations', this.numberOfLocations);

		let userIds: any = [];
		for (let user of filteredUsers) {
			userIds.push(user.id);
		}
		// console.log(userIds);

		this.numberOfUsers = userIds.length;
		let allPrograms: any = this.getFilteredPrograms(userIds);
		// console.log(allPrograms);
		this.coursesInProgress = allPrograms.length;
		await this.getFavoriteCategories(allPrograms);
		// this.filterBarGraph(allPrograms);

		this.tableData = this.getTableData(allPrograms, userIds);
		// console.log(this.tableData);
		this.sortByHierarchy();
		this.progressData = new MatTableDataSource<any>(this.tableData);
		this.progressData.sort = this.sort;
		this.progressData.paginator = this.paginator;
		this.isShowDataEnabled = false;
		this.programCompletion = [];

		// Create an initial dataset for program completion stats.
		for (let i = 0; i < this.tableData.length; i += 1) {
			if (!this.orgData?.hiddenPrograms.includes(this.tableData[i].programId) && this.orgData?.allowedPrograms.includes(this.tableData[i].programId)) {
				let indexOfProgram = this.programCompletion.findIndex((el: any) => el.id === this.tableData[i].programId);
				if (indexOfProgram === -1) {
					if (this.tableData[i].programName) {
						if (this.tableData[i].progress === 100) {
							this.programCompletion.push({ id: this.tableData[i].programId, name: this.tableData[i].programName, userCompleted: 1, notStarted: 0, inProgress: 0 });
						} else {
							this.programCompletion.push({ id: this.tableData[i].programId, name: this.tableData[i].programName, userCompleted: 0, notStarted: 0, inProgress: 1 });
						}
					}
				} else {
					if (this.tableData[i].progress === 100) {
						this.programCompletion[indexOfProgram].userCompleted += 1;
					} else {
						this.programCompletion[indexOfProgram].inProgress += 1;
					}
				}
			}
		}

		// Do separate processing for programs that have been allowed / blocked on role-basis.
		for (let i = 0; i < this.programCompletion.length; i += 1) {
			let item = this.programCompletion[i];
			const eligibleUsers = this.getEligibleLearners(item.id, filteredUsers);
			item.totalUser = eligibleUsers.length;

			if (item.totalUser !== this.numberOfUsers) {
				const filteredPrograms: any = this.getFilteredProgramsByUsers(eligibleUsers, item.id);
				item.userCompleted = 0;
				item.inProgress = 0;

				for (let program of filteredPrograms) {
					if (program.progress === 100) {
						item.userCompleted += 1;
					} else {
						item.inProgress += 1;
					}
				}
			}
		}

		// Set percentages for each program.
		for (let i = 0; i < this.programCompletion.length; i += 1) {
			let item = this.programCompletion[i];

			// Ensure safe number evaluations
			const totalUser = isNaN(Number(item.totalUser)) ? 0 : Number(item.totalUser);
			const userCompleted = isNaN(Number(item.userCompleted)) ? 0 : Number(item.userCompleted);
			const inProgress = isNaN(Number(item.inProgress)) ? 0 : Number(item.inProgress);

			// Calculate notStarted safely
			item.notStarted = totalUser - userCompleted - inProgress;
			item.notStarted = isNaN(item.notStarted) ? 0 : item.notStarted;

			// Calculate percentages
			item.completedPercentage = this.getCompletionPercentage(userCompleted, totalUser);
			item.progressPercentage = this.getCompletionPercentage(inProgress, totalUser);
			item.notStartedPercentage = this.getCompletionPercentage(item.notStarted, totalUser);

			// Adjust for floating point diff (ensure total = 100)
			const diff = 100 - Number(item.completedPercentage) - Number(item.progressPercentage) - Number(item.notStartedPercentage);
			if (!isNaN(diff) && diff !== 0) {
				item.notStartedPercentage += diff;
			}
		}

		// To update latest name for the program from programs collection.
		this.updateNameInArray(this.programCompletion);
		this.sortProgramCompletion();

		this.calculateNewLearnersMonth(filteredUsers);
	}

	getFilteredProgramsByUsers(users: any, programId: string, progressData?: any) {
		if (!Array.isArray(users) || users.length === 0) {
			// Return empty array if users is null, undefined, or not an array or empty
			return [];
		}
		let dataToFilter: any;
		if (progressData) {
			dataToFilter = progressData;
		} else {
			dataToFilter = this.tableData;
		}

		const filteredPrograms = dataToFilter.filter((program: any) => {
			if (program.programId === programId) {
				for (let user of users) {
					if (user.id === program.userId) {
						return true;
					}
				}
			}

			return false;
		});

		return filteredPrograms;
	}

	getEligibleLearnersCount(programId: string, usersAtLocation: any) {
		if (this.orgData?.programAccess && this.orgData.programAccess.length >= 1) {
			let programAccess = this.orgData.programAccess;

			const programIndex = programAccess.findIndex((p: any) => {
				if (p.programId === programId) {
					return true;
				}
			});

			if (programIndex === -1) {
				return usersAtLocation.length;
			}

			let restrictedRoles = [];
			for (let program of programAccess) {
				if (program.programId === programId && !program.allowed) {
					restrictedRoles.push(program.roleId);
				}
			}

			if (restrictedRoles.length === 0) {
				return usersAtLocation.length;
			}

			let eligibleLearners = usersAtLocation.length;
			let filteredUsers = usersAtLocation;

			for (let item of restrictedRoles) {
				const roleCount = this.getRoleCount(item, filteredUsers);
				eligibleLearners -= roleCount;
			}

			return eligibleLearners;
		}

		return this.numberOfUsers;
	}

	getEligibleLearners(programId: string, usersAtLocation: any) {
		if (this.orgData?.programAccess && this.orgData.programAccess.length >= 1) {
			let programAccess = this.orgData.programAccess;

			const programIndex = programAccess.findIndex((p: any) => {
				if (p.programId === programId) {
					return true;
				}
			});

			if (programIndex === -1) {
				return usersAtLocation;
			}

			let restrictedRoles = [];
			for (let program of programAccess) {
				if (program.programId === programId && !program.allowed) {
					restrictedRoles.push(program.roleId);
				}
			}

			if (restrictedRoles.length === 0) {
				return usersAtLocation;
			}

			let eligibleLearners = usersAtLocation;
			for (let item of restrictedRoles) {
				eligibleLearners = eligibleLearners.filter((user: any) => {
					if (user.roleId !== item) {
						return true;
					}

					return false;
				});
			}

			return eligibleLearners;
		}

		return usersAtLocation;
	}

	getRoleCount(roleId: string, usersList?: any) {
		let count = 0;

		let users: any;
		if (usersList) {
			users = usersList;
		} else {
			users = this.allUsersInOrg;
		}

		for (let user of users) {
			if (user.roleId === roleId) {
				count += 1;
			}
		}

		return count;
	}

	updateNameInArray(arr: any) {
		for (let item of arr) {
			let latestProgramData = this.allSystemPrograms.find((program: any) => program.id === item.id);
			if (latestProgramData && latestProgramData.name) {
				if (item.name !== latestProgramData.name) {
					item.name = latestProgramData.name;
				}
			}
		}
	}

	sortProgramCompletion() {
		const data = this.programCompletion.slice();

		this.programCompletion = data.sort((a: any, b: any) => {
			return this.compare(a.userCompleted, b.userCompleted, false);
		});
	}

	isProgramValid(programName: string) {
		const index = this.allSystemPrograms.findIndex((el: any) => {
			return el.name === programName;
		});
		if (index === -1) {
			return false;
		}
		return true;
	}

	updateDropdownValues() {
		for (let i = 0; i < this.orgData.hierarchy.length; i += 1) {
			this.dropdownOptions[i] = [];

			if (this.managerAtLevelValues[i].length >= 1) {
				for (let j = 0; j < this.managerAtLevelValues[i].length; j += 1) {
					let mgrAtVal = this.managerAtLevelValues[i][j];
					let currLevel = this.orgData.hierarchy[i].values;
					let displayValue = "";
					for (let lvl of currLevel) {
						if (lvl.value === mgrAtVal) {
							displayValue = lvl.displayValue;
						}
					}
					this.dropdownOptions[i].push({
						value: mgrAtVal,
						displayValue
					})
				}
				// this.dropdownOptions[i] = [...this.managerAtLevelValues[i]];
			} else {
				let values: any = [];
				let slicedCurrLevels = this.currLevels.slice(0, i);

				for (let val of this.orgData.hierarchy[i].values) {
					let isValidVal = true;
					// console.log(val);

					for (let j = 0; j < val.levels.length; j += 1) {
						if (slicedCurrLevels[j] === "all") {
							if (this.managerAtLevelValues[j].length >= 1) {
								if (!this.managerAtLevelValues[j].includes(val.levels[j])) {
									// console.log('ret false 1');
									isValidVal = false;
									break;
								}
							}
						} else {
							if (slicedCurrLevels[j] !== val.levels[j]) {
								// console.log('ret false 2');
								isValidVal = false;
								break;
							}
						}
					}

					if (isValidVal && !values.includes(val.value)) {
						values.push({
							value: val.value,
							displayValue: val.displayValue
						});
					}
				}

				// console.log(values);
				this.dropdownOptions[i] = values;
			}
		}

		this.sortDropdownOptions();
	}

	getTableData(allPrograms: any, userIds: any) {
		let tableData: any = [];
		let programsWithAttemptedQuizzes = 0;
		let quizAnswerProgress = 0;
		let totalEarnedPts = 0;
		let totalLearningTime = 0;
		let streaks = [];

		if (allPrograms.length >= 1) {
			for (let program of allPrograms) {
				const userId = program.userId;
				const userDetails: any = this.allUsersInOrg.find((user: any) => {
					return user.id === userId;
				});
				// console.log(userDetails);
				let programData = Object.assign({}, program);
				// console.log(programData);
				const programName = programData.name;
				programData.name = userDetails.name;
				programData.programName = programName;

				if (programData.attemptedQuizzes >= 1) {
					programData.avgQuizScore = Math.ceil(programData.quizAnswerProgress);
					quizAnswerProgress += programData.quizAnswerProgress;
					programsWithAttemptedQuizzes += 1;
				} else {
					programData.avgQuizScore = 0;
				}
				programData.earnedPts = this.getEarnedPoints(programData);

				totalEarnedPts += programData.earnedPts;
				// if (programData.learningHistory[this.currentMonthAndYear]) {
				// 	totalLearningTime += programData.learningHistory[this.currentMonthAndYear];
				// }
				totalLearningTime += programData.learningDuration;
				if (programData.learningHistory[this.currentMonthAndYear]) {
				}
				streaks.push(this.calculateStreakForProgram(programData.daysInRow));

				for (let userLevel of userDetails.level) {
					// programData[userLevel.name] = userLevel.value;
					programData[userLevel.name] = userLevel.displayValue;
				}
				tableData.push(programData);
			}

			this.avgPointsPerPerson = Math.round(totalEarnedPts / allPrograms.length);
			if (programsWithAttemptedQuizzes >= 1) {
				this.avgQuizScore = Math.round(quizAnswerProgress / programsWithAttemptedQuizzes);
			}
			this.calculateAvgTimes(totalLearningTime, this.numberOfUsers);
			this.avgStreakPerPerson = streaks.reduce((partialSum, element: any) => {
				return partialSum + element
			}, 0) / allPrograms.length;
			this.avgStreakPerPerson = Math.round(this.avgStreakPerPerson);
		}

		let nonEnrolledUsers: any = this.getNonEnrolledUsers(allPrograms, userIds);
		// console.log(nonEnrolledUsers);
		for (let userId of nonEnrolledUsers) {
			let user = this.allUsersInOrg.find((u: any) => u.id === userId);
			for (let level of user.level) {
				user[level.name] = level.displayValue;
			}
			// console.log(user);
			tableData.push(user);
		}

		return tableData;
	}

	getNonEnrolledUsers(allPrograms: any, userIds: any) {
		let nonEnrolledUsers: any = [...userIds];

		for (let program of allPrograms) {
			let idIndex = nonEnrolledUsers.findIndex((element: any) => element === program.userId);

			if (idIndex !== -1) {
				nonEnrolledUsers.splice(idIndex, 1);
			}
		}

		return nonEnrolledUsers;
	}

	getFilteredUsers() {
		// console.log(this.currLevels);
		const filteredUsers = this.allUsersInOrg.filter((user: any) => {
			// console.log();
			// console.log(user);
			for (let j = 0; j < this.currLevels.length; j += 1) {
				if (this.currLevels[j] === "all") {
					if (!user.level[j] || !user.level[j].value) {
						if (this.managerAtLevelValues[j].length >= 1) {
							// console.log('ret false 1');
							return false;
						}
					} else {
						if (!this.isInDropdownOptions(j, user.level[j].value)) {
							// if (!this.dropdownOptions[j].includes(user.level[j].value)) {
							// console.log('ret false 2');
							return false;
						}
					}
				} else if (user.level[j] && user.level[j].value !== this.currLevels[j]) {
					// console.log('ret false 3');
					return false;
				} else if (!user.level[j]) {
					return false;
				}
			}

			if (!this.selectedRoles.includes(user.roleId) && !this.selectedRoles.includes('all')) {
				return false;
			}

			// console.log('ret true');
			return true;
		});

		// console.log(filteredUsers);
		return filteredUsers;
	}

	isInDropdownOptions(j: any, val: string) {
		let currLvl = this.dropdownOptions[j];
		for (let lvl of currLvl) {
			if (lvl.value === val) {
				return true;
			}
		}

		return false;
	}

	getFilteredPrograms(userIds: any) {
		let programs: any = [];

		programs = this.allPrograms.filter((program: any) => {
			return userIds.includes(program.userId);
		});

		// console.log(this.selectedProgramId);

		// if (this.selectedProgramId !== "all") {
		// 	programs = programs.filter((program: any) => {
		// 		return program.programId === this.selectedProgramId;
		// 	});
		// }

		if (this.selectedProgramIds?.length) {
			programs = programs.filter((program: any) => this.selectedProgramIds.includes(program.programId));
		}
		if (!this.getFilteredProgramsFnInitialCall && this.selectedProgramIds.length === 0 && !this.allSelected) {
			programs = []
		}
		this.getFilteredProgramsFnInitialCall = false;

		return programs;
	}

	async filterByProgram(programId: string) {
		this.selectedProgramId = programId;
		await this.filtering();
	}

	allSelected = false;
	selectedProgramIds: string[] = []; // Stores selected program IDs

	async toggleAllSelection() {
		if (!this.allSelected) {
			this.selectedProgramIds = ['all', ...this.allSystemPrograms.map((program: any) => program.id)];
		} else {
			this.selectedProgramIds = [];
		}

		this.allSelected = this.selectedProgramIds.length === this.allSystemPrograms.length + 1; // +1 for 'all'

		await this.filtering();
		console.log('Selected Programs:', this.selectedProgramIds);
	}

	async optionClick() {
		this.allSelected = this.selectedProgramIds.length === this.allSystemPrograms.length;

		this.selectedProgramIds = this.selectedProgramIds.filter(id => id !== 'all'); // Remove "all"

		await this.filtering();
		console.log('Selected Programs:', this.selectedProgramIds);
	}

	calculateAvgTimes(totalLearningTime: number, numUsers: number) {
		let avgLearningSeconds = totalLearningTime / numUsers;
		this.avgLearningTime = this.sharedService.secondsToHms(avgLearningSeconds);
	}

	calculateStreakForProgram(daysInRow: any) {
		daysInRow.filter((day: any) => day.endsWith(this.currentMonthAndYear));
		let isConsecutive = false;
		let streakCount = 0;

		if (daysInRow.length === 1) {
			return 1;
		}

		for (let i = 1; i < daysInRow.length; i += 1) {
			if (Number(daysInRow[i]) - 1 === Number(daysInRow[i - 1]) && !isConsecutive) {
				isConsecutive = true;
				streakCount += 1;
			} else {
				isConsecutive = false;
			}
		}

		return streakCount;
	}

	getTotalEarnedPts(sections: any) {
		let earnedPts = 0;

		if (sections?.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu' || section.type === 'Menu') {
					earnedPts += this.getTotalEarnedPts(section.menu);
				} else if (section.type === 'video' || section.type === 'download' || section.type === 'Video' || section.type === 'Download') {
					if (section.progress && section.pts) {
						const videoPts = (section.pts * section.progress) / 100;
						// console.log(videoPts);
						earnedPts += videoPts;
					}
				}
			}
		}

		return earnedPts;
	}

	sortByHierarchy() {
		const data = this.tableData.slice();
		this.tableData = data.sort((a: any, b: any) => {
			// console.log(a.name);
			return this.compare(`${this.getAllLevels(a)}${a.name}`, `${this.getAllLevels(b)}${b.name}`, true);
		});
	}

	compare(a: number | string, b: number | string, isAsc: boolean) {
		return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
	}

	getAllLevels(a: any) {
		let levels = "";

		for (let level of this.orgLevels) {
			if (a[level]) {
				levels += a[level];
			}
		}

		return levels;
	}

	getManagingDetails() {
		for (let i = 0; i < this.orgData.hierarchy.length; i += 1) {
			const hierarchyLevel = this.orgData.hierarchy[i];
			this.managerAtLevelValues[i] = [];

			for (let val of hierarchyLevel.values) {
				if (val.managers && val.managers.includes(this.userId)) {
					if (this.managerAtLevelNumber === -1) {
						this.managerAtLevelNumber = i;
						this.prevLevels = val.levels;
						this.currLevels = [...this.prevLevels];
						this.currLevels[i - 1] = "all";

						for (let j = this.prevLevels.length; j < this.orgData.hierarchy.length; j += 1) {
							this.currLevels.push("all");
						}
					}

					this.managerAtLevelValues[i].push(val.value);
				}
			}
		}

		// console.log(this.managerAtLevelValues);
	}

	capitalizeFirstWord(word: string) {
		return word.charAt(0).toUpperCase() + word.slice(1);
	}

	getNumberOfLocations() {
		let numberOfLocations = 0;
		const hierarchy = this.orgData.hierarchy;
		const values = hierarchy[hierarchy.length - 1].values;

		for (let val of values) {
			// console.log(val);
			let isLocationValid = true;

			for (let i = 0; i < this.currLevels.length; i += 1) {
				// if (this.currLevels[i] === "all" && !this.dropdownOptions[i].includes(val.levels[i]) && !this.dropdownOptions[i].includes(val.value)) {
				if (this.currLevels[i] === "all" && !this.isInDropdownOptions(i, val.levels[i]) && !this.isInDropdownOptions(i, val.value)) {
					// console.log('ret false 1');
					isLocationValid = false;
					break;
				} else if (this.currLevels[i] !== "all") {
					if (val.levels[i] !== this.currLevels[i] && val.value !== this.currLevels[i]) {
						// console.log('ret false 2');
						isLocationValid = false;
						break;
					}
				}
			}

			if (isLocationValid) {
				// console.log('adding to loc')
				numberOfLocations += 1;
			}
		}

		return numberOfLocations;
	}

	getDropdownValue(index: number) {
		const value = this.currLevels[index];
		if (value) {
			return value;
		}

		if (index === 0) {
			return "all";
		}

		const options = this.dropdownOptions[index];
		if (Array.isArray(options) && options.length >= 1) {
			return options[0].value;
		}

		return "all";
	}

	ensureDefaultLevelSelections() {
		for (let i = 0; i < this.orgLevels.length; i += 1) {
			if (this.currLevels[i]) {
				continue;
			}

			this.currLevels[i] = this.getDropdownValue(i);
		}
	}

	ensureCurrLevelsInitialized() {
		if (!Array.isArray(this.currLevels)) {
			this.currLevels = [];
		}

		const totalLevels = this.orgData?.hierarchy?.length || this.orgLevels.length || 0;
		for (let i = 0; i < totalLevels; i += 1) {
			if (!this.currLevels[i]) {
				this.currLevels[i] = "all";
			}
		}
	}

	getEarnedPoints(programData: any) {
		let earnedPts = programData.earnedPts;
		earnedPts += this.getTotalEarnedPts(programData.sections);
		return Math.ceil(earnedPts);
	}

	generateCompanyAverage() {
		if (!this.teamAnalyticsData || (this.teamAnalyticsData && this.teamAnalyticsData.length <= 0)) {
			this.companyAverage = 0;
			this.companyAveragePercentage = 0;
			return 0;
		}

		let allUsersAverageDosesTotal = 0;
		for (let user of this.teamAnalyticsData) {
			let userTotalDoses = 0;
			for (let program of user.progressData) {
				const programDoses = this.sharedService.getDosesCompletedForProgram(program);
				userTotalDoses += programDoses;
			}
			const userDetails = this.getUserDetails(user.id);
			if (userDetails) {
				userTotalDoses += this.getUserPodcastDoses(userDetails);
				userTotalDoses += this.getUserMiniclipDoses(userDetails);
			}

			let userMonthsOnSystem = this.getUserMonthsOnSystem(user);
			user.avgMonthlyDoses = userTotalDoses / userMonthsOnSystem;
			if (!user.avgMonthlyDoses || isNaN(user.avgMonthlyDoses)) {
				user.avgMonthlyDoses = 0;
			}

			allUsersAverageDosesTotal += user.avgMonthlyDoses;
		}

		this.companyAverage = Math.round(allUsersAverageDosesTotal / this.teamAnalyticsData.length);
		this.companyAveragePercentage = Math.round((this.companyAverage * 100) / 20);

		if (this.companyAveragePercentage > 100) {
			this.companyAveragePercentage = 100;
		}
	}

	async generateIndustryAverage() {
		// const allUsers = await this.usersService.getAllUserIdsAllOrgs();
		// const getAnalyticsData = this.fns.httpsCallable('analytics-getAnalyticsDatav2');
		// const getAnalyticsDataObs = getAnalyticsData({});
		// const getAnalyticsRes: any = await this.sharedService.getObservableRes(getAnalyticsDataObs);
		// const data = getAnalyticsRes.mergedData;

		// if (!data || (data && data.length <= 0)) {
		// 	this.industryAverage = 0;
		// 	this.industryAveragePercentage = 0;
		// 	return;
		// }

		// // let allPrograms: any = [];
		// let allUsersAverageDosesTotal = 0;

		// for (let user of data) {
		// 	let userTotalDoses = 0;
		// 	for (let program of user.progressData) {
		// 		const programDoses = this.sharedService.getDosesCompletedForProgram(program);
		// 		userTotalDoses += programDoses;
		// 	}
		// 	const userDetails = this.getUserDetails(user.id);
		// 	if (userDetails) {
		// 		userTotalDoses += this.getUserPodcastDoses(userDetails);
		// 		userTotalDoses += this.getUserMiniclipDoses(userDetails);
		// 	}

		// 	let userMonthsOnSystem = this.getUserMonthsOnSystem(user);
		// 	user.avgMonthlyDoses = userTotalDoses / userMonthsOnSystem;
		// 	if (!user.avgMonthlyDoses || isNaN(user.avgMonthlyDoses)) {
		// 		user.avgMonthlyDoses = 0;
		// 	}

		// 	allUsersAverageDosesTotal += user.avgMonthlyDoses;
		// }

		// this.industryAverage = Math.round(allUsersAverageDosesTotal / data.length);
		// this.industryAveragePercentage = Math.round((this.industryAverage * 100) / 20);

		// if (this.industryAveragePercentage > 100) {
		// 	this.industryAveragePercentage = 100;
		// }

		const communityAnalytics: any = await this.analyticsService.getCommunityAnalytics();
		this.industryAverage = communityAnalytics.industryAverage;
		this.industryAveragePercentage = Math.round((this.industryAverage * 100) / 20);
		if (this.industryAveragePercentage > 100) {
			this.industryAveragePercentage = 100;
		}
	}

	getUserMonthsOnSystem(user: any) {
		if (!user.createdAt) {
			return 1;
		}
		return this.sharedService.getMonthsFromCurrent(user.createdAt);
	}

	generateTeamAverage() {
		let users: any = [];

		// func call to get locations where this user is manager.
		let locationsList: any = this.getLocationsList();

		if (locationsList.length <= 0) {
			if (this.userData.level && this.userData.level.length === 0) {
				// users = this.allUsersInOrg.filter((user: any) => {
				// 	if (user && user.level && user.level.length === 0) {
				// 		return true;
				// 	}
				// 	return false;
				// });
				this.teamAverage = this.companyAverage;
				this.teamAveragePercentage = this.companyAveragePercentage;
				return;
			} else {
				let levels = this.userData.level;

				users = this.allUsersInOrg.filter((user: any) => {
					if (user && user.level && user.level.length >= 1) {
						for (let i = 0; i < levels.length; i += 1) {
							if (!user.level[i] || user.level[i].value !== levels[i].value) {
								return false;
							}
						}

						return true;
					}

					return false;
				});
			}
		} else {
			for (let location of locationsList) {
				if (location.length >= 1) {
					let usersAtLocation = this.allUsersInOrg.filter((user: any) => {
						if (user && user.level && user.level.length >= 1) {
							for (let i = 0; i < location.length; i += 1) {
								let levelAtI = location[i];

								if (!user.level[i] || user.level[i].value !== levelAtI) {
									return false;
								}
							}

							return true;
						}
					});

					users = [...users, ...usersAtLocation];
				}
			}
		}

		let allUsersAverageDosesTotal = 0;
		for (let user of users) {
			let userDetails = this.teamAnalyticsData.find((searchUser: any) => {
				return searchUser.id === user.id;
			});
			allUsersAverageDosesTotal += (userDetails && userDetails.avgMonthlyDoses) ? userDetails.avgMonthlyDoses : 0;
		}

		if (users.length >= 1) {
			this.teamAverage = Math.round(allUsersAverageDosesTotal / users.length);
			// calculate % out of goal: 20
			this.teamAveragePercentage = Math.round((this.teamAverage * 100) / 20);
		} else {
			this.teamAverage = 0;
			this.teamAveragePercentage = 0;
		}

		if (this.teamAveragePercentage > 100) {
			this.teamAveragePercentage = 100;
		}
	}

	getLocationsList() {
		let locations: any = [];

		for (let hierarchyLevel of this.orgData.hierarchy) {
			const levelValues = hierarchyLevel.values;

			for (let levelVal of levelValues) {
				// console.log(levelVal);
				if (levelVal.managers && levelVal.managers.length >= 1) {
					// console.log("Found managers.");
					if (levelVal.managers.includes(this.userId)) {
						// console.log("Mgr confirmed!");
						let currVal = levelVal.levels && levelVal.levels.length >= 1 ? levelVal.levels : [];
						currVal.push(levelVal.value);
						locations.push(currVal);
					}
				}
			}
		}

		// console.log(locations);
		return locations;
	}

	getDosesCompleted() {
		let dosesCompleted = 0;
		if (this.userActivePrograms.length >= 1) {
			for (let program of this.userActivePrograms) {
				if (program.dosesCompleted && Object.keys(program.dosesCompleted).length >= 1) {
					for (let monthKey of Object.keys(program.dosesCompleted)) {
						const doses = program.dosesCompleted[monthKey];
						for (let dateKey of Object.keys(doses)) {
							dosesCompleted += doses[dateKey];
						}
					}
				}
			}
		}

		if (this.userData && this.userData.miniClipsData && this.userData.miniClipsData.length >= 1) {
			let mcData = this.userData.miniClipsData;

			for (let item of mcData) {
				let data = item.miniClipData;

				for (let clip of data) {
					if (clip.completed) {
						dosesCompleted += 1;
					}
				}
			}
		}

		if (this.userData && this.userData.podcastsProgress && this.userData.podcastsProgress.length >= 1) {
			let podcastsProgress = this.userData.podcastsProgress;

			for (let item of podcastsProgress) {
				if (item.progress === 100) {
					dosesCompleted += 1;
				}
			}
		}

		return dosesCompleted;
	}

	async getFavoriteCategories(allPrograms: any) {
		const getCategoryAndCount: any = this.getCategoryCount(allPrograms);
		// console.log(getCategoryAndCount);

		if (Object.keys(getCategoryAndCount).length <= 0) {
			this.favoriteCategories = [
				{
					name: "Customer Experience",
					count: 0,
					share: 0
				},
				{
					name: "Management",
					count: 0,
					share: 0
				}
			];
		} else {
			this.favoriteCategories = [];

			for (let key of Object.keys(getCategoryAndCount)) {
				const categoryDetails: any = await this.sharedService.getCategoryDetails(key);
				if (categoryDetails.name) {
					this.favoriteCategories.push({
						id: key,
						name: categoryDetails.name,
						count: getCategoryAndCount[key],
						share: Math.round((getCategoryAndCount[key] * 100) / allPrograms.length)
					});
				}
			}

			// console.log(this.favoriteCategories);
			// sorts in descending order
			this.sortByShare();
		}
	}

	getCategoryCount(allPrograms: any) {
		let categoryAndCount: any = {};

		for (let program of allPrograms) {
			if (categoryAndCount[program.category.id]) {
				categoryAndCount[program.category.id] += 1;
			} else {
				categoryAndCount[program.category.id] = 1;
			}
		}

		return categoryAndCount;
	}

	sortByShare() {
		const favoriteCategories = [...this.favoriteCategories];

		this.favoriteCategories = favoriteCategories.sort((a: any, b: any) => {
			return a.share < b.share ? 1 : -1;
		});
	}

	filterBarGraph(allPrograms: any) {
		this.initBarGraph();

		for (let program of allPrograms) {
			let dosesCompleted = program.dosesCompleted;

			if (dosesCompleted && Object.keys(dosesCompleted).length >= 1 && dosesCompleted[this.currentMonthAndYear]) {
				let dosesThisMonth = dosesCompleted[this.currentMonthAndYear];

				for (let date of Object.keys(dosesThisMonth)) {
					this.dailyDoseBars[Number(date) - 1] += dosesThisMonth[date];
				}
			}
		}
	}

	initBarGraph() {
		let totalDays: number = 0;
		this.dailyDoseBars = [];

		if (["01", "03", "05", "07", "08", "10", "12"].includes(this.currentMonth)) {
			totalDays = 31;
		} else if (["04", "06", "09", "11"].includes(this.currentMonth)) {
			totalDays = 30;
		} else if (this.currentMonth === "02") {
			if (this.sharedService.isLeapYear()) {
				totalDays = 29;
			} else {
				totalDays = 28;
			}
		}

		for (let i = 0; i < totalDays; i += 1) {
			this.dailyDoseBars.push(0);
		}
	}

	changeSortTable(event: any) {
		let sortField = event.active.toLowerCase();
		if (sortField === "started") {
			sortField = "startedAt";
		} else if (sortField === "completed") {
			sortField = "completedAt";
		}
		const data = this.tableData.slice();
		const isAsc = event.direction === 'asc';
		this.tableData = data.sort((a: any, b: any) => {
			if (!a[sortField]) {
				a[sortField] = "-";
			}

			if (!b[sortField]) {
				b[sortField] = "-";
			}
			// console.log(`Comparing ${a[sortField]} with ${b[sortField]}`);
			return this.compare(a[sortField], b[sortField], isAsc);
		});

		// console.log(this.tableData);

		this.progressData = new MatTableDataSource<any>(this.tableData);
		this.progressData.sort = this.sort;
		this.progressData.paginator = this.paginator;
	}

	sortDropdownOptions() {
		for (let i = 0; i < this.dropdownOptions.length; i += 1) {
			if (this.dropdownOptions[i] && this.dropdownOptions[i].length >= 1) {
				const data = this.dropdownOptions[i];
				let sortedData = data.sort((a: any, b: any) => {
					return this.compare(a.value, b.value, true);
				});

				this.dropdownOptions[i] = sortedData;
			}
		}
	}

	async getUpdatedAnalytics() {
		this.snackbar.open("Getting updated analytics...", "OK");
		this.analyticsButtonStatus = false;
		this.getProgressData();
	}

	async refreshOrgData() {
		if (!this.orgId) {
			this.lastUpdatedAt = null;
			return;
		}

		this.orgData = await this.analyticsService.getOrgData(this.orgId);
		this.analyticsButtonStatus = Boolean(this.orgData?.analyticsGenerated);
		this.lastUpdatedAt = this.toDateValue(this.orgData?.analyticsUpdatedAt);
	}

	toDateValue(value: any) {
		if (!value) {
			return null;
		}

		if (value instanceof Date) {
			return value;
		}

		if (value?.toDate && typeof value.toDate === 'function') {
			return value.toDate();
		}

		if (typeof value === 'number') {
			const millis = value > 9999999999 ? value : value * 1000;
			return new Date(millis);
		}

		if (value?.seconds) {
			return new Date(value.seconds * 1000);
		}

		if (value?._seconds) {
			return new Date(value._seconds * 1000);
		}

		const parsedDate = new Date(value);
		return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
	}

	async updateAdminAnalyticsCollection() {
		const data = {
			avgStreakPerPerson: this.avgStreakPerPerson,
			avgLearningTime: this.avgLearningTime,
			coursesInProgress: this.coursesInProgress,
			avgQuizScore: this.avgQuizScore,
			avgPointsPerPerson: this.avgPointsPerPerson,
			numberOfLocations: this.numberOfLocations,
			numberOfUsers: this.numberOfUsers,
			companyAverage: this.companyAverage,
			teamAverage: this.teamAverage,
			industryAverage: this.industryAverage,
			dosesCompleted: this.dosesCompleted,
			dailyDoseBars: this.dailyDoseBars,
			lastUpdatedAt: new Date(),
			programCompletion: this.programCompletion
		};

		await this.analyticsService.updateAdminAnalyticsCollection(this.orgId, data);
	}

	// async getInitialData() {
	// 	const initialData: any = await this.analyticsService.getInitialData(this.orgId);

	// 	if (initialData) {
	// 		this.avgStreakPerPerson = initialData.avgStreakPerPerson;
	// 		this.avgLearningTime = initialData.avgLearningTime;
	// 		this.coursesInProgress = initialData.coursesInProgress;
	// 		this.avgQuizScore = initialData.avgQuizScore;
	// 		this.avgPointsPerPerson = initialData.avgPointsPerPerson;
	// 		this.numberOfLocations = initialData.numberOfLocations;
	// 		this.numberOfUsers = initialData.numberOfUsers;
	// 		this.companyAverage = initialData.companyAverage;
	// 		this.teamAverage = initialData.teamAverage;
	// 		this.industryAverage = initialData?.industryAverage;
	// 		this.dosesCompleted = initialData.dosesCompleted;
	// 		this.dailyDoseBars = initialData.dailyDoseBars;
	// 		this.programCompletion = initialData.programCompletion;
	// 		const lastUpdatedAtSeconds = initialData.lastUpdatedAt.seconds ? initialData.lastUpdatedAt.seconds : initialData.lastUpdatedAt._seconds;

	// 		this.lastUpdatedAt = new Date(lastUpdatedAtSeconds * 1000);
	// 		// console.log(this.lastUpdatedAt);
	// 	}
	// }

	exportToExcel() {
		let allData: any = [];
		for (let obj of this.tableData) {
			const userDetails = this.getUserDetails(obj.userId);
			obj.empCode = userDetails.empCode ? userDetails.empCode : (userDetails.email ? userDetails.email : "-");
			obj.role = this.rolesData[userDetails.roleId];
			let hierarchyObj: any = {};
			let monthsSinceStarted = this.getUserMonthsOnSystem(userDetails);
			let lifetimeDoses = this.getUserLifetimeDoses(obj.userId, userDetails);

			for (let key in obj) {
				if (this.orgLevels.includes(key)) {
					hierarchyObj[key] = obj[key];
				}
			}

			let userPrograms = this.getUserPrograms(obj.userId);
			let num_doses = this.getUserDoseCountMonthly(userDetails, userPrograms);
			let avgLearningThisMonth = this.getUserAvgLearning(userPrograms);

			let createdAt = userDetails.createdAt ? userDetails.createdAt : "";
			if (createdAt && createdAt._seconds) {
				createdAt = moment(new Date(createdAt._seconds * 1000)).format("DD-MM-YYYY");
			} else if (createdAt && createdAt.seconds) {
				createdAt = moment(new Date(createdAt.seconds * 1000)).format("DD-MM-YYYY");
			}

			let startedAt = obj.startedAt ? obj.startedAt : "";
			if (startedAt && startedAt._seconds) {
				startedAt = new Date(startedAt._seconds * 1000).toDateString();
			} else if (startedAt && startedAt.seconds) {
				startedAt = new Date(startedAt.seconds * 1000).toDateString();
			}

			let completedAt = obj.completedAt ? obj.completedAt : "";
			if (completedAt && completedAt._seconds) {
				completedAt = new Date(completedAt._seconds * 1000).toDateString();
			} else if (completedAt && completedAt.seconds) {
				completedAt = new Date(completedAt.seconds * 1000).toDateString();
			}

			let newObj: any = {
				...hierarchyObj,
				name: obj.name,
				empCode: obj.empCode,
				role: obj.role,
				num_doses,
				createdAt: createdAt ? createdAt : "-",
				monthsSinceStarted,
				lifetimeDoses,
				avgLearningThisMonth,
				programName: obj.programName ? obj.programName : "-",
				startedAt: startedAt ? startedAt : "-",
				completedAt: completedAt ? completedAt : "-",
				progress: obj.progress ? obj.progress : "-",
				avgQuizScore: obj.avgQuizScore ? obj.avgQuizScore : "-",
				earnedPts: obj.earnedPts ? obj.earnedPts : "-"
			};
			allData.push(newObj);
		}

		// console.log('allData', allData)
		if (Array.isArray(allData) && allData.length > 0 && typeof allData[0] === 'object') {
			const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(allData);
			const wb: XLSX.WorkBook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

			XLSX.writeFile(wb, 'Analytics.xlsx');
			this.posthog.capture(POSTHOG_EVENT_EXPORT_ANALYTICS_PROGRAM_LIST, {
				'user email': localStorage.getItem('username'),
				'device_type': this.deviceDetectorService.device,
				'role': localStorage.getItem('roleId')
			});
		} else {
			console.error('Invalid data format for export');
		}
	}

	getUserDetails(userId: string) {
		for (let user of this.allUsersInOrg) {
			if (user.id === userId) {
				return user;
			}
		}

		return {};
	}

	getCompletionPercentage(userCompleted: any, totalUser: any) {
		let result = (userCompleted * 100) / totalUser;
		const res = Math.floor(result);
		return isNaN(res) ? 0 : res;
	}

	compareByLevel(level: any, i: number, isDisabled: boolean) {
		if (isDisabled || this.isLowerThanSelectedLevels(i)) {
			return;
		}
		this.compareBoxes = [];
		this.compareBoxesPrograms = [];
		// console.log(this.tableData);

		const dropdownOptions = this.dropdownOptions[i];

		for (let option of dropdownOptions) {
			this.compareBoxes.push({
				name: option.value,
				displayName: option.displayValue,
				numUsers: 0,
				programs: [],
				// userList: []
			});
		}

		for (let data of this.tableData) {
			if (data.programId && data.programName && !this.orgData?.hiddenPrograms.includes(data.programId) && this.orgData?.allowedPrograms.includes(data.programId)) {
				const index = this.compareBoxesPrograms.findIndex((program: any) => {
					return program.id === data.programId;
				});

				if (index === -1) {
					this.compareBoxesPrograms.push({
						id: data.programId,
						name: data.programName
					});
				}
			}
		}

		// console.log(this.compareBoxesPrograms);

		for (let program of this.compareBoxesPrograms) {
			for (let box of this.compareBoxes) {
				box.programs.push({
					id: program.id,
					numCompleted: 0,
					numProgress: 0,
					numNotStarted: 0,
					numUsers: 0,
					eligibleUsers: 0
				});
			}
		}

		this.updateNameInArray(this.compareBoxesPrograms);

		for (let box of this.compareBoxes) {
			const levelName = box.name;
			const filteredProgress: any = this.getFilteredLevelProgress(levelName);
			// console.log(filteredProgress);

			for (let progressData of filteredProgress) {
				if (progressData.programName) {
					const index = box.programs.findIndex((program: any) => program.id === progressData.programId);

					let numCompleted, numProgress;
					if (progressData.progress === 100) {
						numCompleted = box.programs[index].numCompleted + 1;
						numProgress = box.programs[index].numProgress;
					} else {
						numCompleted = box.programs[index].numCompleted;
						numProgress = box.programs[index].numProgress + 1;
					}
					let numUsers = box.programs[index].numUsers + 1;
					box.programs[index].numUsers = numUsers;
					box.programs[index].numCompleted = numCompleted;
					box.programs[index].numProgress = numProgress;
					// if (!box.userList.includes(progressData.userId)) {
					// 	box.userList.push(progressData.userId);
					// }
				}
			}
		}

		const filteredUsersDropdowns = this.getFilteredUsers();
		let allUsersAllLocations = [];

		// Set up compare boxes for cases where programs are role-based.
		for (let box of this.compareBoxes) {
			let usersByLocation = this.getUsersByPreciseLocation(box.name, filteredUsersDropdowns);
			allUsersAllLocations.push(...usersByLocation);
			box.numUsers = usersByLocation.length;

			for (let program of box.programs) {
				program.eligibleUsers = this.getEligibleLearners(program.id, usersByLocation);
				program.eligibleUsersCount = program.eligibleUsers.length;

				if (program.numUsers !== program.eligibleUsersCount) {
					program.numCompleted = 0;
					program.numProgress = 0;
				}
			}
		}

		for (let box of this.compareBoxes) {
			for (let program of box.programs) {
				if (program.numUsers !== program.eligibleUsersCount) {
					const filteredProgressBox: any = this.getFilteredLevelProgress(box.name);
					const filteredPrograms: any = this.getFilteredProgramsByUsers(program.eligibleUsers, program.id, filteredProgressBox);

					for (let filteredProgram of filteredPrograms) {
						if (filteredProgram.programName) {
							if (filteredProgram.progress === 100) {
								program.numCompleted += 1;
							} else {
								program.numProgress += 1;
							}
						}
					}
				}
			}
		}

		for (let box of this.compareBoxes) {
			// box.numUsers = box.userList.length;
			for (let program of box.programs) {
				program.numNotStarted = Number(program.eligibleUsersCount - program.numCompleted - program.numProgress);
				program.completedPercentage = this.getCompletionPercentage(program.numCompleted, program.eligibleUsersCount);
				program.progressPercentage = this.getCompletionPercentage(program.numProgress, program.eligibleUsersCount);
				program.notStartedPercentage = this.getCompletionPercentage(program.numNotStarted, program.eligibleUsersCount);

				const diff = 100 - Number(program.completedPercentage) - Number(program.progressPercentage) - Number(program.notStartedPercentage);
				if (diff !== 0) {
					program.notStartedPercentage += diff;
				}
			}
		}

		for (let program of this.compareBoxesPrograms) {
			program.enrollmentCount = this.getProgramEnrollmentCount(program.id);
		}

		const cbpData = this.compareBoxesPrograms.slice();
		this.compareBoxesPrograms = cbpData.sort((a: any, b: any) => {
			return this.compare(a.enrollmentCount, b.enrollmentCount, false);
		});

		for (let box of this.compareBoxes) {
			for (let program of box.programs) {
				program.totalEnrollmentCount = this.getProgramEnrollmentCount(program.id);
			}
		}

		for (let box of this.compareBoxes) {
			const cbPrograms = box.programs.slice();
			box.programs = cbPrograms.sort((a: any, b: any) => {
				return this.compare(a.totalEnrollmentCount, b.totalEnrollmentCount, false);
			});
		}
	}

	getProgramEnrollmentCount(programId: string) {
		let count = 0;

		for (let box of this.compareBoxes) {
			let program = box.programs.find((item: any) => item.id === programId);
			count += program.numUsers;
		}

		return count;
	}

	getFilteredLevelProgress(levelName: string) {
		let filteredData: any = [];
		for (let data of this.tableData) {
			if (data && data[this.comparisonSelection] && data[this.comparisonSelection].toLowerCase() === levelName && !this.orgData?.hiddenPrograms.includes(data.programId) && this.orgData.allowedPrograms.includes(data.programId)) {
				filteredData.push(data);
			}
		}

		return filteredData;
	}

	getUsersByPreciseLocation(levelName: string, filteredUsersDropdowns: any) {
		// console.log(levelName);

		let filteredUsersLocation: any = [];
		for (let user of filteredUsersDropdowns) {
			if (this.isUserAtLevel(user.level, levelName)) {
				filteredUsersLocation.push(user);
			}
		}

		// console.log(filteredUsersLocation);
		return filteredUsersLocation;
	}

	isUserInArray(user: any, array: any) {
		for (let item of array) {
			if (item.id === user.id) {
				return true;
			}
		}

		return false;
	}

	isUserAtLevel(levels: any, levelName: string) {
		for (let i = 0; i < levels.length; i += 1) {
			if (levels[i].name === this.comparisonSelection && levels[i].value === levelName) {
				return true;
			}
		}
		return false;
	}

	expandProgramContainer() {
		this.isExpand = !this.isExpand;
	}

	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		this.getImageDimensions();
	}

	getImageDimensions() {
		const divHeight = this.cardElement.nativeElement.offsetHeight;
		if (divHeight) this.dyanamicHeight = divHeight;
		// console.log('Div Height:', divHeight);
	}

	isLowerThanSelectedLevels(index: number) {
		if (this.currLevels.length === 0 || !this.currLevels[index] || this.currLevels[index] === "all") {
			return false;
		}

		return true;
	}

	calculateNewLearnersMonth(filteredUsers: any) {
		this.newLearnersThisMonth = 0;

		for (let user of filteredUsers) {
			if (this.sharedService.isDateOfCurrentMonth(user.createdAt)) {
				this.newLearnersThisMonth += 1;
			}
		}
	}

	getUserDoseCountMonthly(userDetails: any, userPrograms: any) {
		let dosesCompleted = 0;

		if (userPrograms.length >= 1) {
			for (let program of userPrograms) {
				if (program.dosesCompleted && Object.keys(program.dosesCompleted).length >= 1 && program.dosesCompleted[this.currentMonthAndYear]) {
					const doses = program.dosesCompleted[this.currentMonthAndYear];
					for (let key of Object.keys(doses)) {
						dosesCompleted += doses[key];
					}
				}
			}
		}

		if (userDetails && userDetails.miniClipsData && userDetails.miniClipsData.length >= 1) {
			let mcData = userDetails.miniClipsData;

			for (let item of mcData) {
				let data = item.miniClipData;

				for (let clip of data) {
					if (clip.completed && clip.completedAt && this.sharedService.isDateOfCurrentMonth(clip.completedAt)) {
						dosesCompleted += 1;
					}
				}
			}
		}

		if (userDetails && userDetails.podcastsProgress && userDetails.podcastsProgress.length >= 1) {
			let podcastsProgress = userDetails.podcastsProgress;

			for (let item of podcastsProgress) {
				if (item.progress === 100 && item.completedAt && this.sharedService.isDateOfCurrentMonth(item.completedAt)) {
					dosesCompleted += 1;
				}
			}
		}

		return dosesCompleted;
	}

	getUserPrograms(userId: string) {
		return this.tableData.filter((record: any) => {
			return record.userId === userId;
		});
	}

	getUserAvgLearning(userPrograms: any) {
		let learningTime = 0;

		for (let program of userPrograms) {
			if (program.learningHistory && program.learningHistory[this.currentMonthAndYear]) {
				learningTime += program.learningHistory[this.currentMonthAndYear];
			}
		}

		return learningTime / 60;
	}

	getUserLifetimeDoses(userId: string, userDetails: any) {
		let userPrograms = this.getUserPrograms(userId);
		let lifetimeDoses = 0;

		for (let program of userPrograms) {
			if (program.dosesCompleted && Object.keys(program.dosesCompleted).length >= 1) {
				for (let monthKey of Object.keys(program.dosesCompleted)) {
					const doses = program.dosesCompleted[monthKey];
					for (let dateKey of Object.keys(doses)) {
						lifetimeDoses += doses[dateKey];
					}
				}
			}
		}

		if (userDetails && userDetails.miniClipsData && userDetails.miniClipsData.length >= 1) {
			let mcData = userDetails.miniClipsData;

			for (let item of mcData) {
				let data = item.miniClipData;

				for (let clip of data) {
					if (clip.completed) {
						lifetimeDoses += 1;
					}
				}
			}
		}

		if (userDetails && userDetails.podcastsProgress && userDetails.podcastsProgress.length >= 1) {
			let podcastsProgress = userDetails.podcastsProgress;

			for (let item of podcastsProgress) {
				if (item.progress === 100) {
					lifetimeDoses += 1;
				}
			}
		}

		return lifetimeDoses;
	}

	getUserPodcastDoses(userDetails: any) {
		let podcastDoses = 0;

		if (userDetails && userDetails.miniClipsData && userDetails.miniClipsData.length >= 1) {
			let mcData = userDetails.miniClipsData;

			for (let item of mcData) {
				let data = item.miniClipData;

				for (let clip of data) {
					if (clip.completed) {
						podcastDoses += 1;
					}
				}
			}
		}

		return podcastDoses;
	}

	getUserMiniclipDoses(userDetails: any) {
		let miniclipDoses = 0;

		if (userDetails && userDetails.miniClipsData && userDetails.miniClipsData.length >= 1) {
			let mcData = userDetails.miniClipsData;

			for (let item of mcData) {
				let data = item.miniClipData;

				for (let clip of data) {
					if (clip.completed) {
						miniclipDoses += 1;
					}
				}
			}
		}

		return miniclipDoses;
	}

	toggleShowData() {
		this.isShowDataEnabled = !this.isShowDataEnabled;
		if (this.isShowDataEnabled) {
			this.posthog.capture(POSTHOG_EVENT_SHOW_ANALYTICS_PROGRAM_LIST, {
				'user email': localStorage.getItem('username'),
				'device_type': this.deviceDetectorService.device,
				'role': localStorage.getItem('roleId')
			});
		} else {
			this.posthog.capture(POSTHOG_EVENT_HIDE_ANALYTICS_PROGRAM_LIST, {
				'user email': localStorage.getItem('username'),
				'device_type': this.deviceDetectorService.device,
				'role': localStorage.getItem('roleId')
			});
		}
	}

	toggleShowTeamMembers() {
		this.isShowTeamEnabled = !this.isShowTeamEnabled;
	}

	async toggleSelectAllRoles() {
		if (!this.isAllRolesSelected) {
			this.selectedRoles = ['all', ...this.rolesKeys.map((key: any) => key)];
		} else {
			this.selectedRoles = [];
		}
		this.isAllRolesSelected = this.selectedRoles.length === this.rolesKeys.length + 1; // +1 for 'all'

		await this.filtering();
		console.log('Selected Roles:', this.selectedRoles);
	}

	async roleOptionClick() {
		this.isAllRolesSelected = this.selectedRoles.length === this.rolesKeys.length;

		if (this.isAllRolesSelected && !this.selectedRoles.includes('all')) {
			this.selectedRoles = ['all', ...this.rolesKeys];
		} else {
			this.selectedRoles = this.selectedRoles.filter(id => id !== 'all');
		}
		await this.filtering();
		console.log('Selected Roles:', this.selectedRoles);
	}

}
